import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import L from "leaflet";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import cityCord from "../../utility/cityCord.json";
import "./Map.css";
import { Link } from "react-router-dom";

const CityMap = () => {
  const { data, headerIndexes } = useSelector((state) => state.data);
  const [cityStats, setCityStats] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (data && headerIndexes && Object.keys(headerIndexes).length > 0) {
      console.log("Header Indexes:", headerIndexes);
      let cities = {};

      data.forEach((tour) => {
        const cityName = tour[headerIndexes["City"]]?.trim().toLowerCase();
        const type = tour[headerIndexes["TYPE (labels)"]];
        const price = parseFloat(String(tour[headerIndexes["price"]]).trim()) || 0;
        const guideCharge = parseFloat(String(tour[headerIndexes["guide charge"]]).trim()) || 0;
        const transportCharge = parseFloat(String(tour[headerIndexes["transport charge"]]).trim()) || 0;
        const participants = parseInt(String(tour[headerIndexes["Participants (number)"]]).trim(), 10) || 0;
        

        const bookingID = tour[headerIndexes["Booking ID's"]];


        if (!cityName || !bookingID) return;

        if (!cities[cityName]) {
          cities[cityName] = {
            bookings: 0, // Count unique bookings
            revenue: 0,
            lat: 0,
            lng: 0,
            bookingIDs: new Set(), // Use a Set to track unique bookings
          };
        }

        // Calculate revenue only if the booking ID is new
        if (!cities[cityName].bookingIDs.has(bookingID)) {
          let revenue = 0;
          if (type === "Booklet") {
            revenue = price;
          } else if (type === "Private") {
            revenue = price - (guideCharge + transportCharge);
          } else if (type === "Group") {
            revenue = participants * price - guideCharge;
          }
          console.log(`City: ${cityName}, Type: ${type}, Price: ${price}, Guide: ${guideCharge}, Transport: ${transportCharge}, Participants: ${participants}, Revenue: ${revenue}`);
          cities[cityName].revenue += revenue;
          cities[cityName].bookings += 1; // Count unique bookings
          cities[cityName].bookingIDs.add(bookingID); // Store booking ID
        }

        

        // Assign city coordinates if missing
        if (!cities[cityName].lat || !cities[cityName].lng) {
          const coordinates = cityCord[cityName];
          if (coordinates) {
            cities[cityName].lat = coordinates.lat;
            cities[cityName].lng = coordinates.lng;
          } else {
            console.log(`Coordinates missing for city: ${cityName}`);
          }
        }
      });

      console.log("Final city stats:", cities);

      const adjustedCityStats = Object.keys(cities).map((cityName) => ({
        name: cityName.charAt(0).toUpperCase() + cityName.slice(1),
        bookings: cities[cityName].bookings,
        revenue: cities[cityName].revenue,
        lat: cities[cityName].lat,
        lng: cities[cityName].lng,
      }));

      setCityStats(adjustedCityStats);
      setLoading(false);
    }
  }, [data, headerIndexes]);

  if (loading) {
    return <div>Loading data...</div>;
  }

  const center = [53.7798, 7.3055];
  const zoom = 4;

  return (
    <div>
      <MapContainer center={center} zoom={zoom} style={{ width: "60vw", height: "60vh" }} className="mapContainer" attributionControl={false} >
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <TileLayer 
          url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}" 
          opacity={1} 
          zIndex={1}
        />
        {cityStats.length > 0 &&
          cityStats.map((city, index) => {
            let borderColor = "red";
            if (city.revenue > 2000) borderColor = "green";
            else if (city.revenue >= 1000) borderColor = "yellow";

            return (
              <Marker
                key={index}
                position={[city.lat, city.lng]}
                icon={L.divIcon({
                  className: "leaflet-div-icon",
                  html: `<div class="circle-marker" style="border-color: ${borderColor}">${city.bookings}</div>`,
                })}
              >
                <Popup className="custom-popup">
                <Link to={`/city/${encodeURIComponent(city.name.toLowerCase())}`} className="city-link">
                {city.name}
                </Link>
                <p className="small-text">Bookings: {city.bookings}</p>
                <p className="small-text">Revenue: ${city.revenue.toFixed(2)}</p>
                </Popup>
              </Marker>
            );
          })}
      </MapContainer>
    </div>
  );
};

export default CityMap;
